"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import generalFormatter from "../../formatters/general";
import SimpleHtmlFormat from "../simple_html_format";
import EmailLabelEditor from "../email_label_editor";
import WaitingSpinner from "../../components/waiting_spinner";
function recipientsView(recipients, label) {
  return /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line", children: [
    /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label", children: label }),
    /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: recipients.join(", ") })
  ] });
}
function failureMessage() {
  return /* @__PURE__ */ jsx(
    "a",
    {
      className: "email-viewer__attachment-failed has-tip",
      title: "Attachment could not be processed. Contact the sender for a replacement",
      children: /* @__PURE__ */ jsx("i", { className: "fi-alert" })
    }
  );
}
function attachmentView(attachment) {
  const message = attachment.caused_by_failure ? failureMessage() : null;
  return /* @__PURE__ */ jsx("li", { className: "email-viewer__attachment", children: /* @__PURE__ */ jsxs("span", { className: "email-viewer__attachment-name", children: [
    /* @__PURE__ */ jsx("a", { target: "_blank", href: attachment.url, children: attachment.name }),
    message
  ] }) }, attachment.url);
}
function possibleEmailLabelEditor(props) {
  if (props.message.message_type !== "sent") {
    return /* @__PURE__ */ jsx(EmailLabelEditor, { email: props.message });
  }
}
function possibleAdditionalRecipients(props) {
  if (props.message.to && !_.isEmpty(props.message.to)) {
    const additionalRecipients = _.rest(props.message.to);
    if (!_.isEmpty(additionalRecipients)) {
      const recipients = _.map(additionalRecipients, function(address) {
        return address.email;
      });
      return recipientsView(recipients, "Additional recipients");
    }
  }
}
function possibleCc(props) {
  if (props.message.cc && !_.isEmpty(props.message.cc)) {
    const recipients = _.map(props.message.cc, function(address) {
      return address.email;
    });
    return recipientsView(recipients, "CC");
  }
}
function possibleAttachments(props) {
  var attachments = props.message.downloadable_attachments || [];
  if (attachments.length > 0) {
    return /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line email-viewer__attachments", children: [
      /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label", children: "Attachments" }),
      /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: _.map(attachments, attachmentView) })
    ] });
  }
}
class EmailViewer extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      updating: false
    });
    __publicField(this, "possibleDocumentFromEmailLink", () => {
      if (this.props.message.message_type !== "sent" && this.props.documentFromEmail) {
        return /* @__PURE__ */ jsx(
          "button",
          {
            className: "email-viewer__save-button button--confirmation",
            onClick: this.documentFromEmail,
            children: "Save As Document"
          }
        );
      }
    });
    __publicField(this, "documentFromEmail", () => {
      this._withUpdate(
        // The button that calls this only renders when documentFromEmail is set
        this.props.documentFromEmail(this.props.message),
        this.props.documentFromEmailCallback
      );
    });
    __publicField(this, "_withUpdate", (promise, callback) => {
      this.setState({ updating: true });
      promise.then((a) => {
        this.setState({ updating: false });
        if (callback) {
          callback(a);
        }
      }).catch(() => {
        this.setState({ updating: false });
        return {};
      });
    });
  }
  render() {
    const message = this.props.message;
    const wasAutomaticallySentAfterIndexing = !!message.automatically_sent_after_indexing;
    const containerClass = message.message_type === "sent" ? "email-viewer__container--sent" : "";
    return /* @__PURE__ */ jsx(WaitingSpinner, { "data-component": "EmailViewer", when: this.state.updating, children: /* @__PURE__ */ jsxs("div", { className: "email-viewer__container " + containerClass, children: [
      /* @__PURE__ */ jsxs("div", { className: "email-viewer__title", children: [
        message.message_type === "sent" ? "Sent" : "Received",
        " Message",
        " ",
        wasAutomaticallySentAfterIndexing ? "(Automatic)" : ""
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "email-viewer__email highlighted", children: [
        /* @__PURE__ */ jsxs("div", { className: "email-viewer__header", children: [
          /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line activity-item__primary-details", children: [
            /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label", children: "Subject" }),
            /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: message.subject })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "activity-item__secondary-details", children: [
            /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line", children: [
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label activity-item__detail-line-label__from", children: "From" }),
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: message.sender_address })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line", children: [
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label activity-item__detail-line-label__recipient", children: "Recipient" }),
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: message.recipient_address })
            ] }),
            possibleAdditionalRecipients(this.props),
            possibleCc(this.props),
            /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line", children: [
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label", children: "Received" }),
              /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: generalFormatter.dateTime(message.created_at) })
            ] })
          ] }),
          this.possibleDocumentFromEmailLink(),
          possibleEmailLabelEditor(this.props),
          possibleAttachments(this.props)
        ] }),
        /* @__PURE__ */ jsx("div", { className: "email-viewer__body", children: /* @__PURE__ */ jsx(SimpleHtmlFormat, { text: message.text_body }) })
      ] })
    ] }) });
  }
}
export default EmailViewer;
